module.exports = __webpack_public_path__ + "img/knife_push.857b229a.svg";